export type ExportContainer = 'mp4' | 'webm';
export type ExportCodec = 'h264' | 'vp9' | 'av1';

export interface ExportPreset {
  id: string;
  label: string;
  category: 'web' | 'social' | 'broadcast' | 'archive';
  width: number;
  height: number;
  frameRate: number;
  bitrate: number;
  audioBitrate: number;
  container: ExportContainer;
  codec: ExportCodec;
  description: string;
}

export const EXPORT_PRESETS: ExportPreset[] = [
  {
    id: 'match-timeline',
    label: 'Match Timeline',
    category: 'web',
    width: 0,
    height: 0,
    frameRate: 0,
    bitrate: 16_000_000,
    audioBitrate: 192_000,
    container: 'mp4',
    codec: 'h264',
    description: 'Use current composition settings',
  },
  {
    id: 'yt-1080p30',
    label: 'YouTube 1080p30',
    category: 'web',
    width: 1920,
    height: 1080,
    frameRate: 30,
    bitrate: 12_000_000,
    audioBitrate: 192_000,
    container: 'mp4',
    codec: 'h264',
    description: 'Standard YouTube HD upload',
  },
  {
    id: 'yt-4k30',
    label: 'YouTube 4K30',
    category: 'web',
    width: 3840,
    height: 2160,
    frameRate: 30,
    bitrate: 40_000_000,
    audioBitrate: 320_000,
    container: 'mp4',
    codec: 'h264',
    description: 'YouTube Ultra HD',
  },
  {
    id: 'ig-reel',
    label: 'Instagram Reel',
    category: 'social',
    width: 1080,
    height: 1920,
    frameRate: 30,
    bitrate: 8_000_000,
    audioBitrate: 160_000,
    container: 'mp4',
    codec: 'h264',
    description: '9:16 vertical for Reels / Stories',
  },
  {
    id: 'tiktok',
    label: 'TikTok',
    category: 'social',
    width: 1080,
    height: 1920,
    frameRate: 30,
    bitrate: 8_000_000,
    audioBitrate: 160_000,
    container: 'mp4',
    codec: 'h264',
    description: '9:16 TikTok export',
  },
  {
    id: 'broadcast-1080p25',
    label: 'Broadcast 1080p25',
    category: 'broadcast',
    width: 1920,
    height: 1080,
    frameRate: 25,
    bitrate: 50_000_000,
    audioBitrate: 320_000,
    container: 'mp4',
    codec: 'h264',
    description: 'Broadcast-leaning high bitrate',
  },
  {
    id: 'archive-webm',
    label: 'Archive WebM HQ',
    category: 'archive',
    width: 1920,
    height: 1080,
    frameRate: 30,
    bitrate: 20_000_000,
    audioBitrate: 320_000,
    container: 'webm',
    codec: 'vp9',
    description: 'High-quality WebM archive (VP9)',
  },
];

export interface ExportJob {
  id: string;
  presetId: string;
  status: 'idle' | 'preparing' | 'encoding' | 'muxing' | 'done' | 'error' | 'cancelled';
  progress: number;
  error?: string;
  method?: 'webcodecs' | 'mediarecorder';
  startedAt?: number;
  finishedAt?: number;
}
